import { Typography } from '@material-ui/core';
import styled from 'styled-components';

const TeacherCard = styled.div`
	border: solid 0.3px #51515166;
	background-color: #ffffff;
	text-align: left;
	/* padding: 20px; */
	margin: 10px;
	${props => props.theme.breakpoints.up('xs')} {
		min-height: 140px;
		width: 100%;
	}

	${props => props.theme.breakpoints.up('sm')} {
		min-height: 120px;
		width: 250px;
	}

	.card-description {
		color: #515151;
		padding-top: 3px;
		${props => props.theme.breakpoints.up('xs')} {
			font-size: 13px;
			line-height: 16px;
		}
		${props => props.theme.breakpoints.up('sm')} {
			font-size: 16px;
			line-height: 18px;
		}
	}
`;

export default TeacherCard;

export const DescriptionContainer = styled.div`
	padding: 20px;
`;

export const Img = styled.div`
	background-image: url(${props => props.src});
	height: 175px;
	width: 100%;
	background-repeat: no-repeat;
	background-size: ${props => props.size || 'cover'};
	background-position: ${props => props.position || 'top center'};
`;

export const StyledTypography = styled(Typography)`
	&& {
		color: #002b5c;
		font-weight: 400;
		padding-bottom: 12px;
		font-size: 20px;
		line-height: unset;
		${props => props.theme.breakpoints.down('sm')} {
			font-size: 16px;
		}
	}
`;
